import { Text, TwButton as Button, Dialog, TwSelector as Selector, Icon } from '@ui-component-library';

type MuniSelectorDialogProps = {
    isOpen: boolean;
    onClose: () => void;
    munis: Array<{ label: string; value: string }>;
    selectedIds: number[];
    onToggle: (muniId: number) => void;
};

export default function MuniSelectorDialog({
    isOpen,
    onClose,
    munis,
    selectedIds,
    onToggle,
}: MuniSelectorDialogProps) {
    const sortedMunis = munis
        .slice()
        .sort((a, b) => {
            const aSelected = selectedIds.includes(parseInt(a.value));
            const bSelected = selectedIds.includes(parseInt(b.value));
            if (aSelected && !bSelected) return -1;
            if (!aSelected && bSelected) return 1;
            return 0;
        });

    return (
        <Dialog isOpen={isOpen} size="medium" className="overflow-x-hidden">
            <Dialog.Header className="flex justify-between">
                <Text variant="text-base/leading-normal/medium">Välj kommun</Text>
                <Button variant="secondary" size="icon" onClick={onClose}>
                    <Icon name="CrossSimple" className="color-charcoal-500" size="medium" />
                </Button>
            </Dialog.Header>
            <Dialog.Content className="gap-1">
                {sortedMunis.map((muni) => {
                    const muniId = parseInt(muni.value);
                    return (
                        <Selector.Option
                            key={muni.value}
                            label={muni.label}
                            value={muni.value}
                            isSelected={selectedIds.includes(muniId)}
                            onClick={() => onToggle(muniId)}
                            className="w-full"
                        />
                    );
                })}
            </Dialog.Content>
            <Dialog.Footer>
                <Button variant="primary" size="medium" onClick={onClose}>
                    Välj
                </Button>
            </Dialog.Footer>
        </Dialog>
    );
}